const RespondFinderSuccessModal = ({ isOpen, onClose, onViewResponse }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-background rounded-lg shadow-xl w-[384px] h-[341px] flex flex-col items-center justify-center p-6">
        <div className="absolute top-[36px] left-1/2 -translate-x-1/2 w-[94px] h-[94px] rounded-full bg-success-500 flex items-center justify-center">
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
            <circle cx="30" cy="30" r="30" fill="#0AB55F" />
            <path
              d="M18 32L27 41L43 25"
              stroke="white"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h2 className="absolute top-[146px] left-1/2 -translate-x-1/2 w-[312px] text-center font-bold text-[19.2px] leading-[23px] capitalize text-black">
          Respond Submitted Successfully
        </h2>
        <p className="absolute top-[172px] left-1/2 -translate-x-1/2 w-[340px] text-center font-normal text-[13.5px] leading-[16px] text-black/70">
          Your product respond has been sent to customer in the selected category. You'll receive
          suggestions soon—stay tuned for the best offers! 🎉
        </p>
        <button
          className="absolute top-[250px] left-1/2 -translate-x-1/2 w-[324px] h-[55px] flex justify-center items-center rounded-[10px] bg-gradient-to-r from-[#D17707] to-[#E88F20] shadow-md text-white text-lg font-medium capitalize hover:opacity-90 transition-opacity"
          onClick={onViewResponse}
        >
          View Response
        </button>
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          onClick={onClose}
        >
          ✕
        </button>
      </div>
    </div>
  )
}

export default RespondFinderSuccessModal
